import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useLoadMoreFieldsHandler } from './useLoadMoreFieldsHandler';
import { useStrategy } from './useStrategy';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import debounce from 'transmute/debounce';
export const useConditionFieldSelect = filterFamily => {
  const {
    selectedFilterFamily
  } = useContext(SegmentationFiltersInstanceContext);
  const [searchString, setSearchString] = useState('');
  const [isLoadingFields, setIsLoadingFields] = useState(false);
  const {
    getFilterFamilyName
  } = useStrategy();
  const loadMoreFields = useLoadMoreFieldsHandler();
  const filterFamilyName = getFilterFamilyName(filterFamily);
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [selectedFilterFamily]);
  const onSearchChange = useMemo(() => debounce(400, evt => {
    const value = evt.target.value;
    if (value) {
      setIsLoadingFields(true);
    }
    loadMoreFields(filterFamily, 0, value.trim()).finally(() => {
      setIsLoadingFields(false);
    });
    setSearchString(value);
  }), [filterFamily, loadMoreFields]);
  useEffect(() => {
    return () => onSearchChange.cancel();
  }, [onSearchChange]);
  return {
    filterFamilyName,
    inputRef,
    isLoadingFields,
    onSearchChange,
    searchString
  };
};